/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useState } from "react";
import { NavLink as NavLinkRRD, Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "data/firebase";
import { clearAuth, getAuthUser } from "components/Auth/authStore";
import PropTypes from "prop-types";

import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";

const Sidebar = (props) => {
  const [collapseOpen, setCollapseOpen] = useState();
  const navigate = useNavigate();
  const localUser = getAuthUser();
  const hasAuthUser = Boolean(auth.currentUser?.uid || localUser?.id);
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  const closeCollapse = () => {
    setCollapseOpen(false);
  };

  const handleLogout = async (e) => {
    e?.preventDefault?.();
    closeCollapse();

    try {
      await signOut(auth);
    } catch {}

    clearAuth();
    navigate("/auth/login", { replace: true });
  };

  const { logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_self",
    };
  }

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        {}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {}
        {logo ? (
          <NavbarBrand className="pt-0" {...navbarBrandProps}>
            <img
              alt={logo.imgAlt}
              className="navbar-brand-img"
              src={logo.imgSrc}
            />
          </NavbarBrand>
        ) : null}
        {}
        <Collapse navbar isOpen={collapseOpen}>
          {}
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink} target="_self">
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          {}
          {}
          <Nav navbar>
            <NavItem>
              <NavLink
                to="/admin/index"
                tag={NavLinkRRD}
                onClick={closeCollapse}
              >
                <i className="ni ni-tv-2 text-primary" />
                Anasayfa
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to="/admin/content/legends/new"
                tag={NavLinkRRD}
                onClick={closeCollapse}
              >
                <i className="ni ni-fat-add text-primary" />
                Yeni Efsane Ekle
              </NavLink>
            </NavItem>

            <NavItem className="mt-3">
              <NavLink
                to={hasAuthUser ? "/admin/user-profile" : "/auth/login"}
                tag={NavLinkRRD}
                onClick={closeCollapse}
              >
                <i className="ni ni-single-02 text-yellow" />
                Profil
              </NavLink>
            </NavItem>
            {!hasAuthUser && (
              <NavItem>
                <NavLink
                  to="/auth/login"
                  tag={NavLinkRRD}
                  onClick={closeCollapse}
                >
                  <i className="ni ni-key-25 text-info" />
                  Giriş Yap
                </NavLink>
              </NavItem>
            )}
            {!hasAuthUser && (
              <NavItem>
                <NavLink
                  to="/auth/login"
                  tag={NavLinkRRD}
                  onClick={closeCollapse}
                >
                  <i className="ni ni-circle-08 text-pink" />
                  Üye Ol
                </NavLink>
              </NavItem>
            )}
            <NavItem>
              <NavLink href="#logout" onClick={handleLogout}>
                <i className="ni ni-button-power text-danger" />
                Çıkış Yap
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
